/**
 * COMEDY REPUBLIC MERCH - Theme JavaScript
 * Y2K vibes with smooth interactions
 */

(function() {
  'use strict';

  // ============================================
  // CART DRAWER
  // ============================================

  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  cartToggleBtns.forEach(btn => {
    btn.addEventListener('click', openCart);
  });

  cartCloseBtns.forEach(btn => {
    btn.addEventListener('click', closeCart);
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer?.classList.contains('is-open')) {
      closeCart();
    }
  });

  // ============================================
  // ADD TO CART (AJAX)
  // ============================================

  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.innerHTML;

      // Show loading state
      submitBtn.innerHTML = 'Adding... ✨';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const item = await response.json();

        // Update cart count
        updateCartCount();

        // Show success
        submitBtn.innerHTML = 'Added! 🎉';

        // Open cart drawer
        setTimeout(() => {
          openCart();
          refreshCartDrawer();
        }, 500);

        // Reset button
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Add to cart error:', error);
        submitBtn.innerHTML = 'Error! Try again';
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });

  // ============================================
  // CART COUNT UPDATE
  // ============================================

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }

  // ============================================
  // CART QUANTITY CHANGE (AJAX)
  // ============================================

  function initCartChangeButtons() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-change]');
      if (!btn) return;

      e.preventDefault();

      const line = btn.dataset.line;
      const quantity = btn.dataset.quantity;

      if (!line || quantity === undefined) return;

      // Find the parent item and add loading state
      const item = btn.closest('.cart-drawer__item, .cart-page__item');
      if (item) {
        item.classList.add('is-updating');
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(line),
            quantity: parseInt(quantity)
          })
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        const cart = await response.json();

        // Update cart count
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        // Check if we're in the cart drawer or on the cart page
        const isInDrawer = btn.closest('.cart-drawer');

        if (isInDrawer) {
          // Refresh just the cart drawer content (keeps drawer open)
          await refreshCartDrawer();
          if (item) {
            item.classList.remove('is-updating');
          }
        } else {
          // On the full cart page, reload to show updated totals
          window.location.reload();
        }

      } catch (error) {
        console.error('Cart update error:', error);
        if (item) {
          item.classList.remove('is-updating');
        }
        alert('Failed to update cart. Please try again.');
      }
    });
  }

  // Initialize cart change buttons
  initCartChangeButtons();

  // ============================================
  // REFRESH CART DRAWER CONTENT
  // ============================================

  async function refreshCartDrawer() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('.cart-drawer__items');
      const newFooter = doc.querySelector('.cart-drawer__footer');

      if (newContent) {
        const currentContent = document.querySelector('.cart-drawer__items');
        if (currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      }

      if (newFooter) {
        const currentFooter = document.querySelector('.cart-drawer__footer');
        if (currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        } else {
          // Add footer if it doesn't exist
          const drawerContent = document.querySelector('.cart-drawer__content');
          if (drawerContent) {
            drawerContent.insertAdjacentHTML('beforeend', newFooter.outerHTML);
          }
        }
      }
    } catch (error) {
      console.error('Failed to refresh cart drawer:', error);
    }
  }

  // ============================================
  // VARIANT SELECTOR
  // ============================================

  const variantSelects = document.querySelectorAll('[data-option-select]');

  variantSelects.forEach(select => {
    select.addEventListener('change', () => {
      updateVariant();
    });
  });

  function updateVariant() {
    // Get all selected options
    const options = [];
    document.querySelectorAll('[data-option-select]').forEach(select => {
      options.push(select.value);
    });

    // Find matching variant
    if (window.productVariants) {
      const variant = window.productVariants.find(v => {
        return v.options.every((opt, i) => opt === options[i]);
      });

      if (variant) {
        // Update hidden input
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variant.id;
        }

        // Update price
        const priceEl = document.querySelector('.product-main__price');
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }

        // Update add button
        const addBtn = document.querySelector('.product-main__add-btn');
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = 'Add to Cart 🛒';
          } else {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Sold Out 😢';
          }
        }

        // Update image if variant has one
        if (variant.featured_image) {
          const mainImage = document.getElementById('main-product-image');
          if (mainImage) {
            mainImage.src = variant.featured_image.src;
          }
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ============================================
  // INTERSECTION OBSERVER FOR ANIMATIONS
  // ============================================

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe product cards
  document.querySelectorAll('.product-card').forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(card);
  });

  // Add visible styles
  const style = document.createElement('style');
  style.textContent = `
    .product-card.is-visible {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);

  // ============================================
  // FUN CURSOR TRAIL (optional Easter egg)
  // ============================================

  let cursorTrailEnabled = false;

  // Enable with Konami code: ↑↑↓↓←→←→BA
  const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'KeyB', 'KeyA'];
  let konamiIndex = 0;

  document.addEventListener('keydown', (e) => {
    if (e.code === konamiCode[konamiIndex]) {
      konamiIndex++;
      if (konamiIndex === konamiCode.length) {
        cursorTrailEnabled = true;
        konamiIndex = 0;
        showEasterEgg();
      }
    } else {
      konamiIndex = 0;
    }
  });

  function showEasterEgg() {
    const msg = document.createElement('div');
    msg.textContent = '✨ SPARKLE MODE ACTIVATED ✨';
    msg.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: var(--color-primary);
      color: white;
      padding: 2rem 3rem;
      font-family: var(--font-heading);
      font-size: 2rem;
      border-radius: 20px;
      z-index: 10000;
      animation: pop 0.5s ease;
    `;
    document.body.appendChild(msg);
    setTimeout(() => msg.remove(), 2000);
  }

})();
